<div class="kp-table-label-printed d-flex">
    <!--<h5>Geprint</h5>-->

    <table mat-table [dataSource]="dataSource" class="flex-grow-1 example-table table-rounded-corners" matSort
           matSortActive="leverDatumTijdstip" matSortDisableClear matSortDirection="asc" [trackBy]="trackById">

        <!-- labelIsCreated Column -->
        <ng-container matColumnDef="labelIsCreated">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox [(ngModel)]="isAllSelected" (change)='markAll()' *ngIf="_data?.length"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox [(ngModel)]="row.selected" (change)='toggleSelected(row)'></mat-checkbox>
            </td>
        </ng-container>

        <!-- orderNr Column -->
        <ng-container matColumnDef="orderNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Ordernr</th>
            <td mat-cell *matCellDef="let row">{{row.orderNr}}</td>
        </ng-container>

        <!-- datumAangemaakt Column -->
        <ng-container matColumnDef="datumAangemaakt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Aangemaakt</th>
            <td mat-cell *matCellDef="let row">{{row.datumAangemaakt | date:'dd-MM-yyyy HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="debiteurNrs">
            <th mat-header-cell *matHeaderCellDef disableClear>Debiteur</th>
            <td mat-cell *matCellDef="let row">
                <span *ngIf="row.debiteurNrs.length == 1">{{row.debiteurNrs}}</span>
                <span *ngIf="row.debiteurNrs.length > 1"
                      matTooltip="{{row.debiteurNrs.join(', ')}}">{{row.debiteurNrs[0]}}...</span>
        </ng-container>

        <ng-container matColumnDef="leverDatumTijdstip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Leverdatum</th>
            <td mat-cell *matCellDef="let row">{{row.leverDatumTijdstip | date: 'dd-MM-yyyy'}}</td>
        </ng-container>

        <ng-container matColumnDef="leverTijdstip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Levertijdstip</th>
            <td mat-cell *matCellDef="let row">{{row.leverTijdstip}}</td>
        </ng-container>

        <ng-container matColumnDef="kwekerArtikelNr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Kwekerartikelnr</th>
            <td mat-cell *matCellDef="let row">{{row.kwekerArtikelNr}}</td>
        </ng-container>

        <ng-container matColumnDef="klantArtikelOmschrijving">
            <th mat-header-cell *matHeaderCellDef disableClear>Artikelomschrijving</th>
            <td mat-cell *matCellDef="let row">{{row.klantArtikelOmschrijving}}</td>
        </ng-container>

        <ng-container matColumnDef="potmaat">
            <th mat-header-cell *matHeaderCellDef disableClear>Potmaat</th>
            <td mat-cell *matCellDef="let row">{{row.potmaat}}</td>
        </ng-container>

        <ng-container matColumnDef="barCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Barcode</th>
            <td mat-cell *matCellDef="let row">{{row.barCode}}</td>
        </ng-container>

        <ng-container matColumnDef="stickerBelading">
            <th mat-header-cell *matHeaderCellDef disableClear>Besteld</th>
            <td mat-cell *matCellDef="let row">{{row.stickerBelading}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.kp-modified]="row.selected"></tr>
    </table>
</div>
